
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Control } from "react-hook-form";
import { CLOSE_TIMES } from "@/constants/buyerFormOptions";

interface CloseTimeFieldProps {
  control: Control<any>;
  isEditing: boolean;
}

const CloseTimeField = ({ control, isEditing }: CloseTimeFieldProps) => {
  return (
    <FormField
      control={control}
      name="averageCloseTime"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Average Close Time</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            value={field.value}
            disabled={!isEditing}
          >
            <FormControl>
              <SelectTrigger className={!isEditing ? "bg-muted" : ""}>
                <SelectValue placeholder="Select close time" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {CLOSE_TIMES.map((time) => (
                <SelectItem key={time} value={time}>
                  {time}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default CloseTimeField;
